import { Component, Input, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTabsModule } from "@angular/material/tabs";

import { SocialAiAlertsChartComponent } from "../../components/tables/social-ai-alerts-chart/social-ai-alerts-chart.component";
import { SocialAiAlertsTableComponent } from "../../components/tables/social-ai-alerts-table/social-ai-alerts-table.component";

@Component({
  selector: 'app-social-ai-alerts-tab',
  standalone: true,
  imports: [CommonModule,
    MatTabsModule,
    SocialAiAlertsChartComponent,
    SocialAiAlertsTableComponent],
  templateUrl: './social-ai-alerts-tab.component.html',
  styleUrl: './social-ai-alerts-tab.component.scss'
})
export class SocialAiAlertsTabComponent {

  @Input() selectedSiteId!: number | null;
  @Input() selectedPlatformId!: number | null;
  @Input() pages: any[] = [];
  @Input() selectedFormat: string | null = null;
  @Input() selectedAlertType: string | null = null;
  @Input() isPageAlerts: boolean = false;

  @Output() tabChanged = new EventEmitter<'page' | 'table'>();

  activeTab: 'page' | 'table' = 'page';

  onTabChange(index: number) {
    this.activeTab = index === 0 ? 'page' : 'table';
    this.tabChanged.emit(this.activeTab);
  }

}
